import { UseQueryOptions } from 'react-query';
import { useCustomMutate, useCustomQuery } from '../../../../../hooks/query';
import {
  GET_CHECK_ELIGIBILITY,
  GET_EXAM_LEVELS,
  GET_PAYMENT_STATUSES,
  GET_REPORTING_ORGANISATIONS,
  GET_TRANSACTION_TYPES,
  POST_PAYMENT_REPORT_EXPORT_EXCEL,
  POST_PAYMENT_REPORT_SEARCH,
} from './keys';
import {
  getCheckEligibility,
  getOrganisations,
  getPaymentStatuses,
  getReportsExamLevels,
  getTransactionTypes,
  postPaymentReportExportExcel,
  postPaymentReportSearch,
} from '../api-services/api';
import { ServiceError } from '../../../../../hooks/error';
import { DropDownItem } from '../../../../../hooks/dropdown';

export const usePostPaymentReportSearch = (
  onSuccess: (res: any) => void,
  onError: (res: any) => void
) => useCustomMutate(POST_PAYMENT_REPORT_SEARCH, postPaymentReportSearch, { onSuccess, onError });

export const usePostPaymentReportExportExcel = (
  onSuccess: (res: any) => void,
  onError: (res: any) => void
) =>
  useCustomMutate(POST_PAYMENT_REPORT_EXPORT_EXCEL, postPaymentReportExportExcel, {
    onSuccess,
    onError,
  });

/** to get candidate particular
 * @param queryOptions
 * */
export const useGetTransactionTypes = (
  queryOptions?: UseQueryOptions<DropDownItem[], ServiceError, DropDownItem[]>
) =>
  useCustomQuery<DropDownItem[]>(
    [GET_TRANSACTION_TYPES],
    () => getTransactionTypes().then((res) => res.data),
    queryOptions
  );

/** to get candidate particular
 * @param queryOptions
 * */
export const useGetOrganisations = (
  queryOptions?: UseQueryOptions<DropDownItem[], ServiceError, DropDownItem[]>
) =>
  useCustomQuery<DropDownItem[]>(
    [GET_REPORTING_ORGANISATIONS],
    () => getOrganisations().then((res) => res.data),
    queryOptions
  );

/** to get exam level for payment reports
 * @param queryOptions
 * */
export const useGetExamLevels = (
  functionName: string,
  queryOptions?: UseQueryOptions<DropDownItem[], ServiceError, DropDownItem[]>
) =>
  useCustomQuery<DropDownItem[]>(
    [GET_EXAM_LEVELS],
    () => getReportsExamLevels(functionName).then((res) => res.data),
    queryOptions
  );

/** check user eligibility
 * @param queryOptions
 * */
export const useGetCheckEligibility = (queryOptions?: UseQueryOptions<void, ServiceError, void>) =>
  useCustomQuery<void>([GET_CHECK_ELIGIBILITY], () => getCheckEligibility().then(), queryOptions);

/** to get payment statuses
 * @param queryOptions
 * */
export const useGetPaymentStatuses = (
  queryOptions?: UseQueryOptions<DropDownItem[], ServiceError, DropDownItem[]>
) =>
  useCustomQuery<DropDownItem[]>(
    [GET_PAYMENT_STATUSES],
    () => getPaymentStatuses().then((res) => res.data),
    queryOptions
  );
